import React from 'react';

export default function ArrowsSplitIcon({as = React.Fragment, Tag = as, ...props}) {
  return (
    <Tag {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className="icon-arrows-split"><g><path className="secondary" fillRule="nonzero" d="M14 16l-3.45-3.45a12 12 0 0 1 2.96-4.9l2.37-2.36-1.59-1.58A1 1 0 0 1 15 2h6a1 1 0 0 1 1 1v6a1 1 0 0 1-1.7.7l-1.6-1.58-2.36 2.37A8 8 0 0 0 14 16z"/><path className="primary" d="M8.12 5.3l2.37 2.36A12 12 0 0 1 14 16.14V21a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-4.86a8 8 0 0 0-2.34-5.65L5.29 8.12 3.71 9.71A1 1 0 0 1 2 9V3a1 1 0 0 1 1-1h6a1 1 0 0 1 .7 1.7L8.13 5.3z"/></g></svg>
    </Tag>
  )
};
